import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

export const getComapnyList = createAsyncThunk(
  "Get Comapny",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.GET_COMPANY, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const changeCompanyStatus = createAsyncThunk(
  "Change Comapny Status",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        API.Change_Company_Status,
        data
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getComapnyDetails = createAsyncThunk(
  "Get ComapnyDetails",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.GET_COMPANY_DETAIL, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
